// extracted by mini-css-extract-plugin
module.exports = {"success":"ColoredText__success__+2Spm","coral":"ColoredText__coral__RZzfX"};